<template>
  <div class="pageWrapper">
    <nuxt ref="page" />
    <modal />
  </div>
</template>

<script>
import Modal from '~/components/Modal/ModalStack';

export default {
  name: 'UserIframe',
  components: {
    Modal,
  },
  middleware: 'authenticated',
  created() {
    this.$auth.setAxiosHeader(this.$cookies.get('auth'));
  },
};
</script>

<style lang="scss" scoped></style>
